import { Container } from "./Container";
import { Headline } from "./Headline";
import background from "./assets/contact-bg.jpg";
import phone from "./assets/phone.png"
import mail from "./assets/mail.png"
import { useLocation } from "react-router-dom";

export function Footer() {
  const location = useLocation();
  const path = location.pathname; // e.g. "/about"

  // Count slashes in the path
  const isSingleSlash = path.split("/").filter(Boolean).length === 1;

  return (
    <>

      {isSingleSlash && (


        <div className="mt-10 text-center text-xs text-center text-neutral-500 py-4 " style={{ background: `url(${background}) center/cover no-repeat` }}>

          <Container>
            <div className="
      
      bg-white bg-opacity-90 inline-block px-10 py-1 rounded my-12 py-12">
              <Headline
                type="footer"
                title="Hast du noch Fragen oder bist du unsicher?"
                className="text-black text-left"

              />


              <p className="text-left pt-6 text-black text-base font-normal">
                Das ist ganz normal – gerade in so einer emotionalen Situation. Wenn du dir nicht sicher bist, welche Bestattungsart der richtige Weg für dich ist, melde dich gerne bei uns. Wir hören zu, beantworten deine Fragen und begleiten dich einfühlsam bei deiner Entscheidung.
              </p>

              <div>
                <div className="flex justify-start pt-6 space-x-5">
                  <img src={phone} alt="phone"  width={20} className="inline  align-middle"></img>
                  <a href="tel:024037825575" className="text-black text-base font-normal">0240 378 25 575</a>
                </div>
                <div className="flex justify-start pt-4 space-x-5">
                  <img src={mail} alt="mail"  width={20} className="inline  align-middle"></img>
                  <a href="mailto:kundenservice@animaltree.de" className="text-black text-base font-normal">kundenservice@animaltree.de</a>
                </div>
              </div>



            </div></Container>
        </div>)}

      {!isSingleSlash && ( <div className="mt-10"></div> )}
        <div className="font-normal text-slate-700  bg-neutral-100 py-6">
          <Container>
            <div className="flex justify-center text-sm">
              <a href="https://animaltree.de/datenschutz/" target="_blank" rel="noreferrer">
                Datenschutz
              </a>
              <span className="px-3">|</span>
              <a href="https://animaltree.de/agb/" target="_blank" rel="noreferrer">
                AGB
              </a>
              <span className="px-3">|</span>
              <a href="https://animaltree.de/impressum/" target="_blank" rel="noreferrer">
                Impressum
              </a>
            </div>
          </Container>
        </div>
    
    </>

  );
}
